import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';

type Props = {
  message: string;
  restaurant_name: string;
};

const ServiceMessageCard: React.FC<Props> = ({ message, restaurant_name }) => {
  return (
    <div className="rounded-md bg-secondary-container p-4 mx-4 my-4 md:my-0">
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon
            className="h-5 w-5 text-on-secondary-container"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-on-secondary-container">{`Message from ${restaurant_name}`}</h3>
          <div className="mt-2 text-sm text-on-secondary-container">
            <p>{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceMessageCard;
